const COUNTRIES = [
    {
        name: "Ascension Island",
        code: "AC",
        emoji: "🇦🇨",
        unicode: "U+1F1E6 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AC.svg",
        index: 0,
    },
    {
        name: "Andorra",
        code: "AD",
        emoji: "🇦🇩",
        unicode: "U+1F1E6 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg",
        index: 1,
    },
    {
        name: "United Arab Emirates",
        code: "AE",
        emoji: "🇦🇪",
        unicode: "U+1F1E6 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg",
        index: 2,
    },
    {
        name: "Afghanistan",
        code: "AF",
        emoji: "🇦🇫",
        unicode: "U+1F1E6 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg",
        index: 3,
    },
    {
        name: "Antigua & Barbuda",
        code: "AG",
        emoji: "🇦🇬",
        unicode: "U+1F1E6 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AG.svg",
        index: 4,
    },
    {
        name: "Anguilla",
        code: "AI",
        emoji: "🇦🇮",
        unicode: "U+1F1E6 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg",
        index: 5,
    },
    {
        name: "Albania",
        code: "AL",
        emoji: "🇦🇱",
        unicode: "U+1F1E6 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg",
        index: 6,
    },
    {
        name: "Armenia",
        code: "AM",
        emoji: "🇦🇲",
        unicode: "U+1F1E6 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg",
        index: 7,
    },
    {
        name: "Angola",
        code: "AO",
        emoji: "🇦🇴",
        unicode: "U+1F1E6 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg",
        index: 8,
    },
    {
        name: "Antarctica",
        code: "AQ",
        emoji: "🇦🇶",
        unicode: "U+1F1E6 U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AQ.svg",
        index: 9,
    },
    {
        name: "Argentina",
        code: "AR",
        emoji: "🇦🇷",
        unicode: "U+1F1E6 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg",
        index: 10,
    },
    {
        name: "American Samoa",
        code: "AS",
        emoji: "🇦🇸",
        unicode: "U+1F1E6 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg",
        index: 11,
    },
    {
        name: "Austria",
        code: "AT",
        emoji: "🇦🇹",
        unicode: "U+1F1E6 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg",
        index: 12,
    },
    {
        name: "Australia",
        code: "AU",
        emoji: "🇦🇺",
        unicode: "U+1F1E6 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg",
        index: 13,
    },
    {
        name: "Aruba",
        code: "AW",
        emoji: "🇦🇼",
        unicode: "U+1F1E6 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg",
        index: 14,
    },
    {
        name: "Åland Islands",
        code: "AX",
        emoji: "🇦🇽",
        unicode: "U+1F1E6 U+1F1FD",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg",
        index: 15,
    },
    {
        name: "Azerbaijan",
        code: "AZ",
        emoji: "🇦🇿",
        unicode: "U+1F1E6 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg",
        index: 16,
    },
    {
        name: "Bosnia & Herzegovina",
        code: "BA",
        emoji: "🇧🇦",
        unicode: "U+1F1E7 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BA.svg",
        index: 17,
    },
    {
        name: "Barbados",
        code: "BB",
        emoji: "🇧🇧",
        unicode: "U+1F1E7 U+1F1E7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg",
        index: 18,
    },
    {
        name: "Bangladesh",
        code: "BD",
        emoji: "🇧🇩",
        unicode: "U+1F1E7 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg",
        index: 19,
    },
    {
        name: "Belgium",
        code: "BE",
        emoji: "🇧🇪",
        unicode: "U+1F1E7 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg",
        index: 20,
    },
    {
        name: "Burkina Faso",
        code: "BF",
        emoji: "🇧🇫",
        unicode: "U+1F1E7 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg",
        index: 21,
    },
    {
        name: "Bulgaria",
        code: "BG",
        emoji: "🇧🇬",
        unicode: "U+1F1E7 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg",
        index: 22,
    },
    {
        name: "Bahrain",
        code: "BH",
        emoji: "🇧🇭",
        unicode: "U+1F1E7 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg",
        index: 23,
    },
    {
        name: "Burundi",
        code: "BI",
        emoji: "🇧🇮",
        unicode: "U+1F1E7 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg",
        index: 24,
    },
    {
        name: "Benin",
        code: "BJ",
        emoji: "🇧🇯",
        unicode: "U+1F1E7 U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg",
        index: 25,
    },
    {
        name: "St. Barthélemy",
        code: "BL",
        emoji: "🇧🇱",
        unicode: "U+1F1E7 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BL.svg",
        index: 26,
    },
    {
        name: "Bermuda",
        code: "BM",
        emoji: "🇧🇲",
        unicode: "U+1F1E7 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg",
        index: 27,
    },
    {
        name: "Brunei",
        code: "BN",
        emoji: "🇧🇳",
        unicode: "U+1F1E7 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg",
        index: 28,
    },
    {
        name: "Bolivia",
        code: "BO",
        emoji: "🇧🇴",
        unicode: "U+1F1E7 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg",
        index: 29,
    },
    {
        name: "Caribbean Netherlands",
        code: "BQ",
        emoji: "🇧🇶",
        unicode: "U+1F1E7 U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BQ.svg",
        index: 30,
    },
    {
        name: "Brazil",
        code: "BR",
        emoji: "🇧🇷",
        unicode: "U+1F1E7 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg",
        index: 31,
    },
    {
        name: "Bahamas",
        code: "BS",
        emoji: "🇧🇸",
        unicode: "U+1F1E7 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg",
        index: 32,
    },
    {
        name: "Bhutan",
        code: "BT",
        emoji: "🇧🇹",
        unicode: "U+1F1E7 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg",
        index: 33,
    },
    {
        name: "Bouvet Island",
        code: "BV",
        emoji: "🇧🇻",
        unicode: "U+1F1E7 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BV.svg",
        index: 34,
    },
    {
        name: "Botswana",
        code: "BW",
        emoji: "🇧🇼",
        unicode: "U+1F1E7 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg",
        index: 35,
    },
    {
        name: "Belarus",
        code: "BY",
        emoji: "🇧🇾",
        unicode: "U+1F1E7 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg",
        index: 36,
    },
    {
        name: "Belize",
        code: "BZ",
        emoji: "🇧🇿",
        unicode: "U+1F1E7 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg",
        index: 37,
    },
    {
        name: "Canada",
        code: "CA",
        emoji: "🇨🇦",
        unicode: "U+1F1E8 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg",
        index: 38,
    },
    {
        name: "Cocos (Keeling) Islands",
        code: "CC",
        emoji: "🇨🇨",
        unicode: "U+1F1E8 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg",
        index: 39,
    },
    {
        name: "Congo - Kinshasa",
        code: "CD",
        emoji: "🇨🇩",
        unicode: "U+1F1E8 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CD.svg",
        index: 40,
    },
    {
        name: "Central African Republic",
        code: "CF",
        emoji: "🇨🇫",
        unicode: "U+1F1E8 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg",
        index: 41,
    },
    {
        name: "Congo - Brazzaville",
        code: "CG",
        emoji: "🇨🇬",
        unicode: "U+1F1E8 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CG.svg",
        index: 42,
    },
    {
        name: "Switzerland",
        code: "CH",
        emoji: "🇨🇭",
        unicode: "U+1F1E8 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg",
        index: 43,
    },
    {
        name: "Côte d’Ivoire",
        code: "CI",
        emoji: "🇨🇮",
        unicode: "U+1F1E8 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CI.svg",
        index: 44,
    },
    {
        name: "Cook Islands",
        code: "CK",
        emoji: "🇨🇰",
        unicode: "U+1F1E8 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg",
        index: 45,
    },
    {
        name: "Chile",
        code: "CL",
        emoji: "🇨🇱",
        unicode: "U+1F1E8 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg",
        index: 46,
    },
    {
        name: "Cameroon",
        code: "CM",
        emoji: "🇨🇲",
        unicode: "U+1F1E8 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg",
        index: 47,
    },
    {
        name: "China",
        code: "CN",
        emoji: "🇨🇳",
        unicode: "U+1F1E8 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg",
        index: 48,
    },
    {
        name: "Colombia",
        code: "CO",
        emoji: "🇨🇴",
        unicode: "U+1F1E8 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg",
        index: 49,
    },
    {
        name: "Clipperton Island",
        code: "CP",
        emoji: "🇨🇵",
        unicode: "U+1F1E8 U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CP.svg",
        index: 50,
    },
    {
        name: "Costa Rica",
        code: "CR",
        emoji: "🇨🇷",
        unicode: "U+1F1E8 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg",
        index: 51,
    },
    {
        name: "Cuba",
        code: "CU",
        emoji: "🇨🇺",
        unicode: "U+1F1E8 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg",
        index: 52,
    },
    {
        name: "Cape Verde",
        code: "CV",
        emoji: "🇨🇻",
        unicode: "U+1F1E8 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg",
        index: 53,
    },
    {
        name: "Curaçao",
        code: "CW",
        emoji: "🇨🇼",
        unicode: "U+1F1E8 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CW.svg",
        index: 54,
    },
    {
        name: "Christmas Island",
        code: "CX",
        emoji: "🇨🇽",
        unicode: "U+1F1E8 U+1F1FD",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg",
        index: 55,
    },
    {
        name: "Cyprus",
        code: "CY",
        emoji: "🇨🇾",
        unicode: "U+1F1E8 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg",
        index: 56,
    },
    {
        name: "Czechia",
        code: "CZ",
        emoji: "🇨🇿",
        unicode: "U+1F1E8 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CZ.svg",
        index: 57,
    },
    {
        name: "Germany",
        code: "DE",
        emoji: "🇩🇪",
        unicode: "U+1F1E9 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg",
        index: 58,
    },
    {
        name: "Diego Garcia",
        code: "DG",
        emoji: "🇩🇬",
        unicode: "U+1F1E9 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DG.svg",
        index: 59,
    },
    {
        name: "Djibouti",
        code: "DJ",
        emoji: "🇩🇯",
        unicode: "U+1F1E9 U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg",
        index: 60,
    },
    {
        name: "Denmark",
        code: "DK",
        emoji: "🇩🇰",
        unicode: "U+1F1E9 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg",
        index: 61,
    },
    {
        name: "Dominica",
        code: "DM",
        emoji: "🇩🇲",
        unicode: "U+1F1E9 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg",
        index: 62,
    },
    {
        name: "Dominican Republic",
        code: "DO",
        emoji: "🇩🇴",
        unicode: "U+1F1E9 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg",
        index: 63,
    },
    {
        name: "Algeria",
        code: "DZ",
        emoji: "🇩🇿",
        unicode: "U+1F1E9 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg",
        index: 64,
    },
    {
        name: "Ceuta & Melilla",
        code: "EA",
        emoji: "🇪🇦",
        unicode: "U+1F1EA U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EA.svg",
        index: 65,
    },
    {
        name: "Ecuador",
        code: "EC",
        emoji: "🇪🇨",
        unicode: "U+1F1EA U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg",
        index: 66,
    },
    {
        name: "Estonia",
        code: "EE",
        emoji: "🇪🇪",
        unicode: "U+1F1EA U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg",
        index: 67,
    },
    {
        name: "Egypt",
        code: "EG",
        emoji: "🇪🇬",
        unicode: "U+1F1EA U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg",
        index: 68,
    },
    {
        name: "Western Sahara",
        code: "EH",
        emoji: "🇪🇭",
        unicode: "U+1F1EA U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EH.svg",
        index: 69,
    },
    {
        name: "Eritrea",
        code: "ER",
        emoji: "🇪🇷",
        unicode: "U+1F1EA U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg",
        index: 70,
    },
    {
        name: "Spain",
        code: "ES",
        emoji: "🇪🇸",
        unicode: "U+1F1EA U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg",
        index: 71,
    },
    {
        name: "Ethiopia",
        code: "ET",
        emoji: "🇪🇹",
        unicode: "U+1F1EA U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg",
        index: 72,
    },
    {
        name: "Finland",
        code: "FI",
        emoji: "🇫🇮",
        unicode: "U+1F1EB U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg",
        index: 73,
    },
    {
        name: "Fiji",
        code: "FJ",
        emoji: "🇫🇯",
        unicode: "U+1F1EB U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg",
        index: 74,
    },
    {
        name: "Falkland Islands",
        code: "FK",
        emoji: "🇫🇰",
        unicode: "U+1F1EB U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg",
        index: 75,
    },
    {
        name: "Micronesia",
        code: "FM",
        emoji: "🇫🇲",
        unicode: "U+1F1EB U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg",
        index: 76,
    },
    {
        name: "Faroe Islands",
        code: "FO",
        emoji: "🇫🇴",
        unicode: "U+1F1EB U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg",
        index: 77,
    },
    {
        name: "France",
        code: "FR",
        emoji: "🇫🇷",
        unicode: "U+1F1EB U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg",
        index: 78,
    },
    {
        name: "Gabon",
        code: "GA",
        emoji: "🇬🇦",
        unicode: "U+1F1EC U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg",
        index: 79,
    },
    {
        name: "United Kingdom",
        code: "GB",
        emoji: "🇬🇧",
        unicode: "U+1F1EC U+1F1E7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg",
        index: 80,
    },
    {
        name: "Grenada",
        code: "GD",
        emoji: "🇬🇩",
        unicode: "U+1F1EC U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg",
        index: 81,
    },
    {
        name: "Georgia",
        code: "GE",
        emoji: "🇬🇪",
        unicode: "U+1F1EC U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg",
        index: 82,
    },
    {
        name: "French Guiana",
        code: "GF",
        emoji: "🇬🇫",
        unicode: "U+1F1EC U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg",
        index: 83,
    },
    {
        name: "Guernsey",
        code: "GG",
        emoji: "🇬🇬",
        unicode: "U+1F1EC U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GG.svg",
        index: 84,
    },
    {
        name: "Ghana",
        code: "GH",
        emoji: "🇬🇭",
        unicode: "U+1F1EC U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg",
        index: 85,
    },
    {
        name: "Gibraltar",
        code: "GI",
        emoji: "🇬🇮",
        unicode: "U+1F1EC U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg",
        index: 86,
    },
    {
        name: "Greenland",
        code: "GL",
        emoji: "🇬🇱",
        unicode: "U+1F1EC U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg",
        index: 87,
    },
    {
        name: "Gambia",
        code: "GM",
        emoji: "🇬🇲",
        unicode: "U+1F1EC U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg",
        index: 88,
    },
    {
        name: "Guinea",
        code: "GN",
        emoji: "🇬🇳",
        unicode: "U+1F1EC U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg",
        index: 89,
    },
    {
        name: "Guadeloupe",
        code: "GP",
        emoji: "🇬🇵",
        unicode: "U+1F1EC U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg",
        index: 90,
    },
    {
        name: "Equatorial Guinea",
        code: "GQ",
        emoji: "🇬🇶",
        unicode: "U+1F1EC U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg",
        index: 91,
    },
    {
        name: "Greece",
        code: "GR",
        emoji: "🇬🇷",
        unicode: "U+1F1EC U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg",
        index: 92,
    },
    {
        name: "South Georgia & South Sandwich Islands",
        code: "GS",
        emoji: "🇬🇸",
        unicode: "U+1F1EC U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GS.svg",
        index: 93,
    },
    {
        name: "Guatemala",
        code: "GT",
        emoji: "🇬🇹",
        unicode: "U+1F1EC U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg",
        index: 94,
    },
    {
        name: "Guam",
        code: "GU",
        emoji: "🇬🇺",
        unicode: "U+1F1EC U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg",
        index: 95,
    },
    {
        name: "Guinea-Bissau",
        code: "GW",
        emoji: "🇬🇼",
        unicode: "U+1F1EC U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg",
        index: 96,
    },
    {
        name: "Guyana",
        code: "GY",
        emoji: "🇬🇾",
        unicode: "U+1F1EC U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg",
        index: 97,
    },
    {
        name: "Hong Kong SAR China",
        code: "HK",
        emoji: "🇭🇰",
        unicode: "U+1F1ED U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg",
        index: 98,
    },
    {
        name: "Heard & McDonald Islands",
        code: "HM",
        emoji: "🇭🇲",
        unicode: "U+1F1ED U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HM.svg",
        index: 99,
    },
    {
        name: "Honduras",
        code: "HN",
        emoji: "🇭🇳",
        unicode: "U+1F1ED U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg",
        index: 100,
    },
    {
        name: "Croatia",
        code: "HR",
        emoji: "🇭🇷",
        unicode: "U+1F1ED U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg",
        index: 101,
    },
    {
        name: "Haiti",
        code: "HT",
        emoji: "🇭🇹",
        unicode: "U+1F1ED U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg",
        index: 102,
    },
    {
        name: "Hungary",
        code: "HU",
        emoji: "🇭🇺",
        unicode: "U+1F1ED U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg",
        index: 103,
    },
    {
        name: "Canary Islands",
        code: "IC",
        emoji: "🇮🇨",
        unicode: "U+1F1EE U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IC.svg",
        index: 104,
    },
    {
        name: "Indonesia",
        code: "ID",
        emoji: "🇮🇩",
        unicode: "U+1F1EE U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg",
        index: 105,
    },
    {
        name: "Ireland",
        code: "IE",
        emoji: "🇮🇪",
        unicode: "U+1F1EE U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg",
        index: 106,
    },
    {
        name: "Israel",
        code: "IL",
        emoji: "🇮🇱",
        unicode: "U+1F1EE U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg",
        index: 107,
    },
    {
        name: "Isle of Man",
        code: "IM",
        emoji: "🇮🇲",
        unicode: "U+1F1EE U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IM.svg",
        index: 108,
    },
    {
        name: "India",
        code: "IN",
        emoji: "🇮🇳",
        unicode: "U+1F1EE U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
        index: 109,
    },
    {
        name: "British Indian Ocean Territory",
        code: "IO",
        emoji: "🇮🇴",
        unicode: "U+1F1EE U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg",
        index: 110,
    },
    {
        name: "Iraq",
        code: "IQ",
        emoji: "🇮🇶",
        unicode: "U+1F1EE U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg",
        index: 111,
    },
    {
        name: "Iran",
        code: "IR",
        emoji: "🇮🇷",
        unicode: "U+1F1EE U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg",
        index: 112,
    },
    {
        name: "Iceland",
        code: "IS",
        emoji: "🇮🇸",
        unicode: "U+1F1EE U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg",
        index: 113,
    },
    {
        name: "Italy",
        code: "IT",
        emoji: "🇮🇹",
        unicode: "U+1F1EE U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg",
        index: 114,
    },
    {
        name: "Jersey",
        code: "JE",
        emoji: "🇯🇪",
        unicode: "U+1F1EF U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JE.svg",
        index: 115,
    },
    {
        name: "Jamaica",
        code: "JM",
        emoji: "🇯🇲",
        unicode: "U+1F1EF U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg",
        index: 116,
    },
    {
        name: "Jordan",
        code: "JO",
        emoji: "🇯🇴",
        unicode: "U+1F1EF U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg",
        index: 117,
    },
    {
        name: "Japan",
        code: "JP",
        emoji: "🇯🇵",
        unicode: "U+1F1EF U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg",
        index: 118,
    },
    {
        name: "Kenya",
        code: "KE",
        emoji: "🇰🇪",
        unicode: "U+1F1F0 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg",
        index: 119,
    },
    {
        name: "Kyrgyzstan",
        code: "KG",
        emoji: "🇰🇬",
        unicode: "U+1F1F0 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg",
        index: 120,
    },
    {
        name: "Cambodia",
        code: "KH",
        emoji: "🇰🇭",
        unicode: "U+1F1F0 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg",
        index: 121,
    },
    {
        name: "Kiribati",
        code: "KI",
        emoji: "🇰🇮",
        unicode: "U+1F1F0 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg",
        index: 122,
    },
    {
        name: "Comoros",
        code: "KM",
        emoji: "🇰🇲",
        unicode: "U+1F1F0 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg",
        index: 123,
    },
    {
        name: "St. Kitts & Nevis",
        code: "KN",
        emoji: "🇰🇳",
        unicode: "U+1F1F0 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KN.svg",
        index: 124,
    },
    {
        name: "North Korea",
        code: "KP",
        emoji: "🇰🇵",
        unicode: "U+1F1F0 U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg",
        index: 125,
    },
    {
        name: "South Korea",
        code: "KR",
        emoji: "🇰🇷",
        unicode: "U+1F1F0 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg",
        index: 126,
    },
    {
        name: "Kuwait",
        code: "KW",
        emoji: "🇰🇼",
        unicode: "U+1F1F0 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg",
        index: 127,
    },
    {
        name: "Cayman Islands",
        code: "KY",
        emoji: "🇰🇾",
        unicode: "U+1F1F0 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg",
        index: 128,
    },
    {
        name: "Kazakhstan",
        code: "KZ",
        emoji: "🇰🇿",
        unicode: "U+1F1F0 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg",
        index: 129,
    },
    {
        name: "Laos",
        code: "LA",
        emoji: "🇱🇦",
        unicode: "U+1F1F1 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg",
        index: 130,
    },
    {
        name: "Lebanon",
        code: "LB",
        emoji: "🇱🇧",
        unicode: "U+1F1F1 U+1F1E7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg",
        index: 131,
    },
    {
        name: "St. Lucia",
        code: "LC",
        emoji: "🇱🇨",
        unicode: "U+1F1F1 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LC.svg",
        index: 132,
    },
    {
        name: "Liechtenstein",
        code: "LI",
        emoji: "🇱🇮",
        unicode: "U+1F1F1 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg",
        index: 133,
    },
    {
        name: "Sri Lanka",
        code: "LK",
        emoji: "🇱🇰",
        unicode: "U+1F1F1 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg",
        index: 134,
    },
    {
        name: "Liberia",
        code: "LR",
        emoji: "🇱🇷",
        unicode: "U+1F1F1 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg",
        index: 135,
    },
    {
        name: "Lesotho",
        code: "LS",
        emoji: "🇱🇸",
        unicode: "U+1F1F1 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg",
        index: 136,
    },
    {
        name: "Lithuania",
        code: "LT",
        emoji: "🇱🇹",
        unicode: "U+1F1F1 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg",
        index: 137,
    },
    {
        name: "Luxembourg",
        code: "LU",
        emoji: "🇱🇺",
        unicode: "U+1F1F1 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg",
        index: 138,
    },
    {
        name: "Latvia",
        code: "LV",
        emoji: "🇱🇻",
        unicode: "U+1F1F1 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg",
        index: 139,
    },
    {
        name: "Libya",
        code: "LY",
        emoji: "🇱🇾",
        unicode: "U+1F1F1 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg",
        index: 140,
    },
    {
        name: "Morocco",
        code: "MA",
        emoji: "🇲🇦",
        unicode: "U+1F1F2 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg",
        index: 141,
    },
    {
        name: "Monaco",
        code: "MC",
        emoji: "🇲🇨",
        unicode: "U+1F1F2 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg",
        index: 142,
    },
    {
        name: "Moldova",
        code: "MD",
        emoji: "🇲🇩",
        unicode: "U+1F1F2 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg",
        index: 143,
    },
    {
        name: "Montenegro",
        code: "ME",
        emoji: "🇲🇪",
        unicode: "U+1F1F2 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg",
        index: 144,
    },
    {
        name: "St. Martin",
        code: "MF",
        emoji: "🇲🇫",
        unicode: "U+1F1F2 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MF.svg",
        index: 145,
    },
    {
        name: "Madagascar",
        code: "MG",
        emoji: "🇲🇬",
        unicode: "U+1F1F2 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg",
        index: 146,
    },
    {
        name: "Marshall Islands",
        code: "MH",
        emoji: "🇲🇭",
        unicode: "U+1F1F2 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg",
        index: 147,
    },
    {
        name: "North Macedonia",
        code: "MK",
        emoji: "🇲🇰",
        unicode: "U+1F1F2 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MK.svg",
        index: 148,
    },
    {
        name: "Mali",
        code: "ML",
        emoji: "🇲🇱",
        unicode: "U+1F1F2 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg",
        index: 149,
    },
    {
        name: "Myanmar (Burma)",
        code: "MM",
        emoji: "🇲🇲",
        unicode: "U+1F1F2 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MM.svg",
        index: 150,
    },
    {
        name: "Mongolia",
        code: "MN",
        emoji: "🇲🇳",
        unicode: "U+1F1F2 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg",
        index: 151,
    },
    {
        name: "Macao SAR China",
        code: "MO",
        emoji: "🇲🇴",
        unicode: "U+1F1F2 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MO.svg",
        index: 152,
    },
    {
        name: "Northern Mariana Islands",
        code: "MP",
        emoji: "🇲🇵",
        unicode: "U+1F1F2 U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg",
        index: 153,
    },
    {
        name: "Martinique",
        code: "MQ",
        emoji: "🇲🇶",
        unicode: "U+1F1F2 U+1F1F6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg",
        index: 154,
    },
    {
        name: "Mauritania",
        code: "MR",
        emoji: "🇲🇷",
        unicode: "U+1F1F2 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg",
        index: 155,
    },
    {
        name: "Montserrat",
        code: "MS",
        emoji: "🇲🇸",
        unicode: "U+1F1F2 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg",
        index: 156,
    },
    {
        name: "Malta",
        code: "MT",
        emoji: "🇲🇹",
        unicode: "U+1F1F2 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg",
        index: 157,
    },
    {
        name: "Mauritius",
        code: "MU",
        emoji: "🇲🇺",
        unicode: "U+1F1F2 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg",
        index: 158,
    },
    {
        name: "Maldives",
        code: "MV",
        emoji: "🇲🇻",
        unicode: "U+1F1F2 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg",
        index: 159,
    },
    {
        name: "Malawi",
        code: "MW",
        emoji: "🇲🇼",
        unicode: "U+1F1F2 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg",
        index: 160,
    },
    {
        name: "Mexico",
        code: "MX",
        emoji: "🇲🇽",
        unicode: "U+1F1F2 U+1F1FD",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg",
        index: 161,
    },
    {
        name: "Malaysia",
        code: "MY",
        emoji: "🇲🇾",
        unicode: "U+1F1F2 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg",
        index: 162,
    },
    {
        name: "Mozambique",
        code: "MZ",
        emoji: "🇲🇿",
        unicode: "U+1F1F2 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg",
        index: 163,
    },
    {
        name: "Namibia",
        code: "NA",
        emoji: "🇳🇦",
        unicode: "U+1F1F3 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg",
        index: 164,
    },
    {
        name: "New Caledonia",
        code: "NC",
        emoji: "🇳🇨",
        unicode: "U+1F1F3 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg",
        index: 165,
    },
    {
        name: "Niger",
        code: "NE",
        emoji: "🇳🇪",
        unicode: "U+1F1F3 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg",
        index: 166,
    },
    {
        name: "Norfolk Island",
        code: "NF",
        emoji: "🇳🇫",
        unicode: "U+1F1F3 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg",
        index: 167,
    },
    {
        name: "Nigeria",
        code: "NG",
        emoji: "🇳🇬",
        unicode: "U+1F1F3 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg",
        index: 168,
    },
    {
        name: "Nicaragua",
        code: "NI",
        emoji: "🇳🇮",
        unicode: "U+1F1F3 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg",
        index: 169,
    },
    {
        name: "Netherlands",
        code: "NL",
        emoji: "🇳🇱",
        unicode: "U+1F1F3 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg",
        index: 170,
    },
    {
        name: "Norway",
        code: "NO",
        emoji: "🇳🇴",
        unicode: "U+1F1F3 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg",
        index: 171,
    },
    {
        name: "Nepal",
        code: "NP",
        emoji: "🇳🇵",
        unicode: "U+1F1F3 U+1F1F5",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg",
        index: 172,
    },
    {
        name: "Nauru",
        code: "NR",
        emoji: "🇳🇷",
        unicode: "U+1F1F3 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg",
        index: 173,
    },
    {
        name: "Niue",
        code: "NU",
        emoji: "🇳🇺",
        unicode: "U+1F1F3 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg",
        index: 174,
    },
    {
        name: "New Zealand",
        code: "NZ",
        emoji: "🇳🇿",
        unicode: "U+1F1F3 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg",
        index: 175,
    },
    {
        name: "Oman",
        code: "OM",
        emoji: "🇴🇲",
        unicode: "U+1F1F4 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg",
        index: 176,
    },
    {
        name: "Panama",
        code: "PA",
        emoji: "🇵🇦",
        unicode: "U+1F1F5 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg",
        index: 177,
    },
    {
        name: "Peru",
        code: "PE",
        emoji: "🇵🇪",
        unicode: "U+1F1F5 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg",
        index: 178,
    },
    {
        name: "French Polynesia",
        code: "PF",
        emoji: "🇵🇫",
        unicode: "U+1F1F5 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg",
        index: 179,
    },
    {
        name: "Papua New Guinea",
        code: "PG",
        emoji: "🇵🇬",
        unicode: "U+1F1F5 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg",
        index: 180,
    },
    {
        name: "Philippines",
        code: "PH",
        emoji: "🇵🇭",
        unicode: "U+1F1F5 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg",
        index: 181,
    },
    {
        name: "Pakistan",
        code: "PK",
        emoji: "🇵🇰",
        unicode: "U+1F1F5 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg",
        index: 182,
    },
    {
        name: "Poland",
        code: "PL",
        emoji: "🇵🇱",
        unicode: "U+1F1F5 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg",
        index: 183,
    },
    {
        name: "St. Pierre & Miquelon",
        code: "PM",
        emoji: "🇵🇲",
        unicode: "U+1F1F5 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PM.svg",
        index: 184,
    },
    {
        name: "Pitcairn Islands",
        code: "PN",
        emoji: "🇵🇳",
        unicode: "U+1F1F5 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PN.svg",
        index: 185,
    },
    {
        name: "Puerto Rico",
        code: "PR",
        emoji: "🇵🇷",
        unicode: "U+1F1F5 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg",
        index: 186,
    },
    {
        name: "Palestinian Territories",
        code: "PS",
        emoji: "🇵🇸",
        unicode: "U+1F1F5 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PS.svg",
        index: 187,
    },
    {
        name: "Portugal",
        code: "PT",
        emoji: "🇵🇹",
        unicode: "U+1F1F5 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg",
        index: 188,
    },
    {
        name: "Palau",
        code: "PW",
        emoji: "🇵🇼",
        unicode: "U+1F1F5 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg",
        index: 189,
    },
    {
        name: "Paraguay",
        code: "PY",
        emoji: "🇵🇾",
        unicode: "U+1F1F5 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg",
        index: 190,
    },
    {
        name: "Qatar",
        code: "QA",
        emoji: "🇶🇦",
        unicode: "U+1F1F6 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg",
        index: 191,
    },
    {
        name: "Réunion",
        code: "RE",
        emoji: "🇷🇪",
        unicode: "U+1F1F7 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RE.svg",
        index: 192,
    },
    {
        name: "Romania",
        code: "RO",
        emoji: "🇷🇴",
        unicode: "U+1F1F7 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg",
        index: 193,
    },
    {
        name: "Serbia",
        code: "RS",
        emoji: "🇷🇸",
        unicode: "U+1F1F7 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg",
        index: 194,
    },
    {
        name: "Russia",
        code: "RU",
        emoji: "🇷🇺",
        unicode: "U+1F1F7 U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg",
        index: 195,
    },
    {
        name: "Rwanda",
        code: "RW",
        emoji: "🇷🇼",
        unicode: "U+1F1F7 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg",
        index: 196,
    },
    {
        name: "Saudi Arabia",
        code: "SA",
        emoji: "🇸🇦",
        unicode: "U+1F1F8 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg",
        index: 197,
    },
    {
        name: "Solomon Islands",
        code: "SB",
        emoji: "🇸🇧",
        unicode: "U+1F1F8 U+1F1E7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg",
        index: 198,
    },
    {
        name: "Seychelles",
        code: "SC",
        emoji: "🇸🇨",
        unicode: "U+1F1F8 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg",
        index: 199,
    },
    {
        name: "Sudan",
        code: "SD",
        emoji: "🇸🇩",
        unicode: "U+1F1F8 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg",
        index: 200,
    },
    {
        name: "Sweden",
        code: "SE",
        emoji: "🇸🇪",
        unicode: "U+1F1F8 U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg",
        index: 201,
    },
    {
        name: "Singapore",
        code: "SG",
        emoji: "🇸🇬",
        unicode: "U+1F1F8 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg",
        index: 202,
    },
    {
        name: "St. Helena",
        code: "SH",
        emoji: "🇸🇭",
        unicode: "U+1F1F8 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SH.svg",
        index: 203,
    },
    {
        name: "Slovenia",
        code: "SI",
        emoji: "🇸🇮",
        unicode: "U+1F1F8 U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg",
        index: 204,
    },
    {
        name: "Svalbard & Jan Mayen",
        code: "SJ",
        emoji: "🇸🇯",
        unicode: "U+1F1F8 U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SJ.svg",
        index: 205,
    },
    {
        name: "Slovakia",
        code: "SK",
        emoji: "🇸🇰",
        unicode: "U+1F1F8 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg",
        index: 206,
    },
    {
        name: "Sierra Leone",
        code: "SL",
        emoji: "🇸🇱",
        unicode: "U+1F1F8 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg",
        index: 207,
    },
    {
        name: "San Marino",
        code: "SM",
        emoji: "🇸🇲",
        unicode: "U+1F1F8 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg",
        index: 208,
    },
    {
        name: "Senegal",
        code: "SN",
        emoji: "🇸🇳",
        unicode: "U+1F1F8 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg",
        index: 209,
    },
    {
        name: "Somalia",
        code: "SO",
        emoji: "🇸🇴",
        unicode: "U+1F1F8 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg",
        index: 210,
    },
    {
        name: "Suriname",
        code: "SR",
        emoji: "🇸🇷",
        unicode: "U+1F1F8 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg",
        index: 211,
    },
    {
        name: "South Sudan",
        code: "SS",
        emoji: "🇸🇸",
        unicode: "U+1F1F8 U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg",
        index: 212,
    },
    {
        name: "São Tomé & Príncipe",
        code: "ST",
        emoji: "🇸🇹",
        unicode: "U+1F1F8 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ST.svg",
        index: 213,
    },
    {
        name: "El Salvador",
        code: "SV",
        emoji: "🇸🇻",
        unicode: "U+1F1F8 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg",
        index: 214,
    },
    {
        name: "Sint Maarten",
        code: "SX",
        emoji: "🇸🇽",
        unicode: "U+1F1F8 U+1F1FD",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SX.svg",
        index: 215,
    },
    {
        name: "Syria",
        code: "SY",
        emoji: "🇸🇾",
        unicode: "U+1F1F8 U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg",
        index: 216,
    },
    {
        name: "Eswatini",
        code: "SZ",
        emoji: "🇸🇿",
        unicode: "U+1F1F8 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SZ.svg",
        index: 217,
    },
    {
        name: "Tristan da Cunha",
        code: "TA",
        emoji: "🇹🇦",
        unicode: "U+1F1F9 U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TA.svg",
        index: 218,
    },
    {
        name: "Turks & Caicos Islands",
        code: "TC",
        emoji: "🇹🇨",
        unicode: "U+1F1F9 U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TC.svg",
        index: 219,
    },
    {
        name: "Chad",
        code: "TD",
        emoji: "🇹🇩",
        unicode: "U+1F1F9 U+1F1E9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg",
        index: 220,
    },
    {
        name: "French Southern Territories",
        code: "TF",
        emoji: "🇹🇫",
        unicode: "U+1F1F9 U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TF.svg",
        index: 221,
    },
    {
        name: "Togo",
        code: "TG",
        emoji: "🇹🇬",
        unicode: "U+1F1F9 U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg",
        index: 222,
    },
    {
        name: "Thailand",
        code: "TH",
        emoji: "🇹🇭",
        unicode: "U+1F1F9 U+1F1ED",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg",
        index: 223,
    },
    {
        name: "Tajikistan",
        code: "TJ",
        emoji: "🇹🇯",
        unicode: "U+1F1F9 U+1F1EF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg",
        index: 224,
    },
    {
        name: "Tokelau",
        code: "TK",
        emoji: "🇹🇰",
        unicode: "U+1F1F9 U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg",
        index: 225,
    },
    {
        name: "Timor-Leste",
        code: "TL",
        emoji: "🇹🇱",
        unicode: "U+1F1F9 U+1F1F1",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg",
        index: 226,
    },
    {
        name: "Turkmenistan",
        code: "TM",
        emoji: "🇹🇲",
        unicode: "U+1F1F9 U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg",
        index: 227,
    },
    {
        name: "Tunisia",
        code: "TN",
        emoji: "🇹🇳",
        unicode: "U+1F1F9 U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg",
        index: 228,
    },
    {
        name: "Tonga",
        code: "TO",
        emoji: "🇹🇴",
        unicode: "U+1F1F9 U+1F1F4",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg",
        index: 229,
    },
    {
        name: "Turkey",
        code: "TR",
        emoji: "🇹🇷",
        unicode: "U+1F1F9 U+1F1F7",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg",
        index: 230,
    },
    {
        name: "Trinidad & Tobago",
        code: "TT",
        emoji: "🇹🇹",
        unicode: "U+1F1F9 U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TT.svg",
        index: 231,
    },
    {
        name: "Tuvalu",
        code: "TV",
        emoji: "🇹🇻",
        unicode: "U+1F1F9 U+1F1FB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg",
        index: 232,
    },
    {
        name: "Taiwan",
        code: "TW",
        emoji: "🇹🇼",
        unicode: "U+1F1F9 U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg",
        index: 233,
    },
    {
        name: "Tanzania",
        code: "TZ",
        emoji: "🇹🇿",
        unicode: "U+1F1F9 U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg",
        index: 234,
    },
    {
        name: "Ukraine",
        code: "UA",
        emoji: "🇺🇦",
        unicode: "U+1F1FA U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg",
        index: 235,
    },
    {
        name: "Uganda",
        code: "UG",
        emoji: "🇺🇬",
        unicode: "U+1F1FA U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg",
        index: 236,
    },
    {
        name: "U.S. Outlying Islands",
        code: "UM",
        emoji: "🇺🇲",
        unicode: "U+1F1FA U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UM.svg",
        index: 237,
    },
    {
        name: "United Nations",
        code: "UN",
        emoji: "🇺🇳",
        unicode: "U+1F1FA U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UN.svg",
        index: 238,
    },
    {
        name: "United States",
        code: "US",
        emoji: "🇺🇸",
        unicode: "U+1F1FA U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg",
        index: 239,
    },
    {
        name: "Uruguay",
        code: "UY",
        emoji: "🇺🇾",
        unicode: "U+1F1FA U+1F1FE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg",
        index: 240,
    },
    {
        name: "Uzbekistan",
        code: "UZ",
        emoji: "🇺🇿",
        unicode: "U+1F1FA U+1F1FF",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg",
        index: 241,
    },
    {
        name: "Vatican City",
        code: "VA",
        emoji: "🇻🇦",
        unicode: "U+1F1FB U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VA.svg",
        index: 242,
    },
    {
        name: "St. Vincent & Grenadines",
        code: "VC",
        emoji: "🇻🇨",
        unicode: "U+1F1FB U+1F1E8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VC.svg",
        index: 243,
    },
    {
        name: "Venezuela",
        code: "VE",
        emoji: "🇻🇪",
        unicode: "U+1F1FB U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg",
        index: 244,
    },
    {
        name: "British Virgin Islands",
        code: "VG",
        emoji: "🇻🇬",
        unicode: "U+1F1FB U+1F1EC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg",
        index: 245,
    },
    {
        name: "U.S. Virgin Islands",
        code: "VI",
        emoji: "🇻🇮",
        unicode: "U+1F1FB U+1F1EE",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg",
        index: 246,
    },
    {
        name: "Vietnam",
        code: "VN",
        emoji: "🇻🇳",
        unicode: "U+1F1FB U+1F1F3",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg",
        index: 247,
    },
    {
        name: "Vanuatu",
        code: "VU",
        emoji: "🇻🇺",
        unicode: "U+1F1FB U+1F1FA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg",
        index: 248,
    },
    {
        name: "Wallis & Futuna",
        code: "WF",
        emoji: "🇼🇫",
        unicode: "U+1F1FC U+1F1EB",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WF.svg",
        index: 249,
    },
    {
        name: "Samoa",
        code: "WS",
        emoji: "🇼🇸",
        unicode: "U+1F1FC U+1F1F8",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg",
        index: 250,
    },
    {
        name: "Kosovo",
        code: "XK",
        emoji: "🇽🇰",
        unicode: "U+1F1FD U+1F1F0",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/XK.svg",
        index: 251,
    },
    {
        name: "Yemen",
        code: "YE",
        emoji: "🇾🇪",
        unicode: "U+1F1FE U+1F1EA",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg",
        index: 252,
    },
    {
        name: "Mayotte",
        code: "YT",
        emoji: "🇾🇹",
        unicode: "U+1F1FE U+1F1F9",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg",
        index: 253,
    },
    {
        name: "South Africa",
        code: "ZA",
        emoji: "🇿🇦",
        unicode: "U+1F1FF U+1F1E6",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg",
        index: 254,
    },
    {
        name: "Zambia",
        code: "ZM",
        emoji: "🇿🇲",
        unicode: "U+1F1FF U+1F1F2",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg",
        index: 255,
    },
    {
        name: "Zimbabwe",
        code: "ZW",
        emoji: "🇿🇼",
        unicode: "U+1F1FF U+1F1FC",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg",
        index: 256,
    },
    {
        name: "England",
        code: "ENGLAND",
        emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
        unicode: "U+1F3F4 U+E0067 U+E0062 U+E0065 U+E006E U+E0067 U+E007F",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ENGLAND.svg",
        index: 257,
    },
    {
        name: "Scotland",
        code: "SCOTLAND",
        emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        unicode: "U+1F3F4 U+E0067 U+E0062 U+E0073 U+E0063 U+E0074 U+E007F",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SCOTLAND.svg",
        index: 258,
    },
    {
        name: "Wales",
        code: "WALES",
        emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
        unicode: "U+1F3F4 U+E0067 U+E0062 U+E0077 U+E006C U+E0073 U+E007F",
        image: "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WALES.svg",
        index: 259,
    },
];

export const DROPDOWN_COUNTRIES_FORMAT = () => {
    return COUNTRIES.map((el, position) => {
        return {
            index: position,
            key: position,
            header: el.name,
            image: el.image,
            content: "",
            detail: el,
        };
    });
};

export const getCountryNameByCode = (code = "ch") => {
    return COUNTRIES.find((el) => el?.code.toLowerCase() === code.toLowerCase())
        ?.name;
};

export const getDataCountryByCode = (code) => {
    const country = COUNTRIES?.find(
        (el) => el?.code?.toLowerCase() === code?.toLowerCase()
    );
    return {
        index: country?.index,
        header: country?.name,
        image: country?.image,
        content: "",
        detail: country,
    };
};
